import type { I18nFn } from 'i18n/types/I18nFn';

type Args = {
  i18n: I18nFn;
  hasAts: boolean;
};

export function getVolopApplySectionTitle({ i18n, hasAts }: Args) {
  return hasAts
    ? i18n('Apply to This Volunteer Opportunity')
    : i18n('How to Apply');
}
